module.exports = new __parcel__URL__("contact_phone_icon.8f3253c6.svg").toString();